import { H3 } from '@/components/label/H3'

interface Props {
  title: string
  body: string
}
export const Notation: React.FC<Props> = ({ title, body }) => {
  return (
    <>
      <H3 title={title} />
      <div
        className="sm:p-0 px-[10px] mt-[10px] text-justify"
        dangerouslySetInnerHTML={{ __html: body }}
      ></div>
    </>
  )
}
